import React from "../_snowpack/pkg/react.js";
export const TopBar = () => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "topbar"
  }, /* @__PURE__ */ React.createElement("h1", null, "@holymarcell/css-scf-border"));
};
